import * as actions from '../actions/actionTypes';

const initialState = {
  divergences: [],
};

const fetchDivergence = (state, action) => ({ ...state, divergences: action.divergences });
const editDivergence = (state, action) => (
  { ...state, divergences: state.divergences.filter(divergence => divergence.id !== action.id) }
);
const validateDivergence = (state, action) => (
  { ...state, divergences: state.divergences.filter(divergence => divergence.id !== action.id) }
);

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_DIVERGENCE_SUCCESS: return fetchDivergence(state, action);
    case actions.EDIT_DIVERGENCE_SUCCESS: return editDivergence(state, action);
    case actions.VALIDATE_DIVERGENCE_SUCCESS: return validateDivergence(state, action);
    default: return state;
  }
};

export default reducer;
